import React, { useState, useEffect } from 'react';
import { cleanSearch } from 'utils';
import PropTypes from 'prop-types';
import Loader from "components/Loader";
import ShelfProduct from "components/ShelfProduct";
import ShelfPaginator from "components/ShelfPaginator";
import PubSub from 'services/PubSub/';
import TagManagerService from 'services/TagManager';
import Error500 from "components/Error500";
import { withRouter } from 'react-router';
import queryString from "query-string";
import PlpEmpty from "components/Shelf/PlpEmpty";
import productAction from "actions/Product";
import style from './style.scss'; //NOSONAR

let _isMounted = false;
let isCompletedLoaded = true;
let actions = [];
let filterService = null;
let quantity = 0;
let page = 0;

const Shelf = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const {products} = props;

    useEffect(() => {
        _isMounted = true;
        filterService = props.filter;
        page = 0;

        loadMore();

        return () => {
            quantity = 0;
            _isMounted = false;
        };
    }, []);

    useEffect(()=> {
        actions.push(PubSub.register('filter_change', () => {
            reset();
            loadMore();
        }));

        return () => {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    });

    const reset = () => {
        page = 0;
    }

    const loadMore = () => {
        if (_isMounted) {
            isCompletedLoaded = true;
            setIsLoading(true);
        }

        const servicePage = filterService ? filterService.getPage() : 0;
        page = page ? page : servicePage;

        getProducts(page).then((results) => {
            quantity = results && !results.data.status && !results.error && results.resources ? parseInt(results.resources.split('/')[1]) : quantity;
            let totalPages = (quantity > 0) ? Math.ceil(quantity / 40) : 0;

            if(totalPages > 0 && page > totalPages) {
                setPage(totalPages);
            }

            const { search } = filterService;

            if (search && results && results.data && results.data.length === 1 && page === 1) {
                props.history.replace(`/${results.data[0].linkText}/p`);
            } else {
                _renderProds(results);
            }
        });

    }

    const _renderProds = (result) => {
        if(!result){
            isCompletedLoaded = false;
        }

        if(result && result.data && result.data[0]){
            TagManagerService.productImpressions(result.data, filterService.getPromoName(props.title));
        }

        _applyProducts();
    }

    const getProducts = (page) => {
        const {pathname} = props.location;
        let {search} = props.location;

        if(page){
            let params = queryString.parse(search);

            params.page = page;

            if(params.ft){
                params.ft = cleanSearch(params.ft);
            }

            search = '?' + queryString.stringify(params);
        }

        return productAction.getShelfProducts(pathname + search);
    }

    const _applyProducts = () => {
        props.changeQuantity(quantity);

        if (_isMounted) {
            setIsLoading(false);
        }
    }

    const setPage = (paramPage) => {
        if(!filterService) return false;
        filterService.setPage(paramPage);
        page = paramPage;
        loadMore();
    }

    const tagTitle =  filterService ? filterService.getPromoName(props.title) : '';
    const totalPages = (quantity > 0) ? (quantity / 40) : 0;

    return (
        <div className="shelf-wrapper">
            {products.length > 0 && <div className="shelf-content">
                {!isLoading && <ul className="shelf-list">
                    {
                        products.map((product, i) =>
                            <li className="shelf-item" key={product.productId}>
                                <ShelfProduct product={product} position={i} listTitle={tagTitle} />
                            </li>
                        )
                    }
                </ul>}
            </div>}

            {(isCompletedLoaded && (products.length === 0) && !isLoading) && <PlpEmpty/>}

            {!isCompletedLoaded && products.length === 0 && <Error500/>}
            {!isCompletedLoaded && products.length > 0 && <div className='shelf-not-loaded'>
                No se cargaron todos los productos solicitados. <button className='shelf-not-loaded-btn'>Intenta nuevamente</button>
            </div>}
            {isLoading &&
            <div className="shelf-list-loader">
                <Loader />
            </div>}
            {(!isLoading && products.length > 0 && (products.length < quantity)) && <ShelfPaginator pages={totalPages} setPage={setPage} currentPage={Number(page)}/>}

        </div>
    )

};

Shelf.propTypes = {
    filter: PropTypes.object,
    categories: PropTypes.array,
    title: PropTypes.string,
    history: PropTypes.object,
    location: PropTypes.object,
    products: PropTypes.array,
    changeQuantity: PropTypes.func
};

export default withRouter(Shelf);
